export const worldRegions = {
	title: {
		en: "Global Regions Explorer",
		zh: "全球区域探险家",
		ko: "글로벌 지역 탐험가",
	},
	sub_title: {
		en: "Explore the Nations Across Varied Continents and Regions Worldwide",
		zh: "探索世界各地多元的大陆和地区的国家",
		ko: "전 세계 다양한 대륙과 지역의 나라들을 탐험하세요",
	},
};
